import { Checkbox, Grid, MenuItem, Select, TextField } from "@mui/material";
import { Field, FormikProps } from "formik";
import CustomButtonSimple from "../../../../components/CustomMiscellaneous/CustomButtonSimple";
import { CustomErrorMessage } from "../../../../components/FormComponents/CustomErrorMessage";
import { hasError } from "../../../../components/FormComponents/utils";
import { IObra, IOperacao, TipoOperacao } from "../IObra";
import AddIcon from '@mui/icons-material/Add';
import CustomDatePicker from '../../../../form/CustomInput/CustomDatePicker/CustomDatePicker';
import { Dispatch, SetStateAction, SyntheticEvent, useEffect, useRef } from "react";
import { useInsideAlerter, useOutsideAlerter } from "../../../../hooks/outsideClickHook";
import DeleteIcon from '@mui/icons-material/Delete';


export function OperacoesForm({
    saveCurrentState,
    formikProps,
    pecaIndex,
    operacoesArrayHelper,
    setSelectedPecaIndex,
    selectedPecaIndex

}: { saveCurrentState: any, pecaIndex: number, operacoesArrayHelper: any, formikProps: FormikProps<IObra>, setSelectedPecaIndex: Dispatch<SetStateAction<number | null>>, selectedPecaIndex: number | null }) {

    const { values, errors, touched, handleChange, setFieldValue } = formikProps;

    const operacoesRef = useRef(null);

    const eventListenerCb = (event: React.KeyboardEvent) => {
        if ( event.key === 'Enter') {
            event.preventDefault();
            operacoesArrayHelper.push({ tipo: null, observacoes: '', isExternal: false, dataExpedicao: null })
            return;
        }
    }

    const getDataExpedicaoLabel = (value?: IOperacao) => {
        if((value?.isExternal && value?.tipo == TipoOperacao.SERROTE) || value?.tipo == TipoOperacao.SUBCONTRATACAO) {
            return 'Data Entrada';
        }
        return 
        }

    

    return (<div
        className={`p-1 ${selectedPecaIndex !== pecaIndex ? 'hover:bg-red-200 hover:bg-opacity-40 rounded-md' : ''} ${selectedPecaIndex === pecaIndex ? 'border border-red-200 rounded-md' : ''}`}
        ref={operacoesRef}
        onClick={() => setSelectedPecaIndex(pecaIndex)}
        onKeyDown={eventListenerCb}
        tabIndex={0}
    >
        <h2>Operaçoes</h2>
        {values.pecas && values.pecas[pecaIndex] && values.pecas[pecaIndex].operacoes?.length ?
            (values.pecas[pecaIndex].operacoes.map((o: IOperacao, opIdx: number) => {
                const medidaEnabled = values.pecas && values.pecas[pecaIndex].operacoes[opIdx].tipo === 'Serrote';
                const enableDataExpedicao = values.pecas && values.pecas[pecaIndex].operacoes[opIdx].isExternal;
                return (<div className="flex items-center">
                    <Grid container spacing={0.3} className="flex w-11/12 items-center">
                        <Grid item xs={2.5}>
                            <Field
                                className="w-full"
                                name={`pecas.${pecaIndex}.operacoes.${opIdx}.tipo`}
                                size="small"
                                as={Select}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    console.log("new value: ", e.target.value);
                                    handleChange(e)

                                    if (e.target.value !== TipoOperacao.SERROTE) {
                                        setFieldValue(`pecas.${pecaIndex}.operacoes.${opIdx}.medida`, null);
                                    }

                                    if (e.target.value === TipoOperacao.SUBCONTRATACAO || e.target.value === TipoOperacao.TRATAMENTO) {
                                        setFieldValue(`pecas.${pecaIndex}.operacoes.${opIdx}.isExternal`, true);
                                    }

                                }}
                                error={hasError({ errors, touched, name: `pecas.${pecaIndex}.operacoes.${opIdx}.tipo` as any })}
                                variant={'outlined'}
                                label={'Tipo'}>
                                {Object.values(TipoOperacao).filter((t:TipoOperacao) => t != TipoOperacao.EXPEDICAO).map((s: string) => <MenuItem key={s} value={s}>{s}</MenuItem>)}

                            </Field>
                            <CustomErrorMessage name={`pecas.${pecaIndex}.operacoes.${opIdx}.tipo`} />
                        </Grid>
                        <Grid item xs={4}>
                            <Field
                                className="w-full"
                                size="small"
                                name={`pecas.${pecaIndex}.operacoes.${opIdx}.observacoes`}
                                as={TextField}
                                type={"text"}
                                error={hasError({ errors, touched, name: `pecas.${pecaIndex}.operacoes.${opIdx}.observacoes` as any })}
                                variant={'outlined'}
                                label={'Observações'} />
                            <CustomErrorMessage name={`pecas.${pecaIndex}.operacoes.${opIdx}.observacoes`} />
                        </Grid>
                        <Grid item xs={2}>

                            <Field
                                className={`w-full ${!medidaEnabled ? 'bg-zinc-100' : ''}`}
                                disabled={!medidaEnabled}
                                name={`pecas.${pecaIndex}.operacoes.${opIdx}.medida`}
                                size="small"
                                as={TextField}
                                type={"text"}
                                error={hasError({ errors, touched, name: `pecas.${pecaIndex}.operacoes.${opIdx}.medida` as any })}
                                variant={'outlined'}
                                label={'medida'} />
                            <CustomErrorMessage name={`pecas.${pecaIndex}.operacoes.${opIdx}.medida`} />
                        </Grid>
                        <Grid item xs={1}>
                            <div className="text-center">Externa</div>
                            <Field
                                className="w-full"
                                name={`pecas.${pecaIndex}.operacoes.${opIdx}.isExternal`}
                                as={Checkbox}
                                disabled={values.pecas[pecaIndex].operacoes[opIdx].tipo === TipoOperacao.SUBCONTRATACAO || 
                                    values.pecas[pecaIndex].operacoes[opIdx].tipo === TipoOperacao.TRATAMENTO}
                                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                    console.log("new value: ", e.target.checked);
                                    handleChange(e)

                                    if (!e.target.checked) {
                                        setFieldValue(`pecas.${pecaIndex}.operacoes.${opIdx}.dataExpedicao`, null);
                                    }
                                }}
                                checked={values.pecas ? values.pecas[pecaIndex].operacoes[opIdx].isExternal : false}
                                error={hasError({ errors, touched, name: `pecas.${pecaIndex}.operacoes.${opIdx}.isExternal` as any })}
                                variant={'outlined'}
                                label={'Operação externa'} />
                            <CustomErrorMessage name={`pecas.${pecaIndex}.operacoes.${opIdx}.isExternal`} />
                        </Grid>
                        <Grid item xs={2.5}>
                            <>
                                <Field
                                    className="w-full bg-zinc-300"
                                    disabled={!enableDataExpedicao}
                                    name={`pecas.${pecaIndex}.operacoes.${opIdx}.dataExpedicao`}
                                    size="small"
                                    as={CustomDatePicker}
                                    onChange={(value: Date) => {
                                        setFieldValue(`pecas.${pecaIndex}.operacoes.${opIdx}.dataExpedicao`, value)
                                    }}
                                    value={values.pecas ? values.pecas[pecaIndex].operacoes[opIdx].dataExpedicao : new Date()}
                                    error={hasError({ errors, touched, name: `pecas.${pecaIndex}.operacoes.${opIdx}.dataExpedicao` as any })}
                                    variant={'outlined'}
                                    label={ getDataExpedicaoLabel(values.pecas ? values.pecas[pecaIndex].operacoes[opIdx] : undefined)} />
                                <CustomErrorMessage name={`pecas.${pecaIndex}.operacoes.${opIdx}.dataExpedicao`} />
                            </>

                        </Grid>


                    </Grid>
                    <div className="w-1/12 flex justify-center">
                        <DeleteIcon className="text-red-400 cursor-pointer" onClick={() => operacoesArrayHelper.remove(opIdx)} />

                    </div>
                    
                </div>)

            }))

            : null}

        <CustomButtonSimple className={'h-7 mt-2 px-1 mb-2'} text="Adicionar operação" Icon={AddIcon} onClick={() => {
            operacoesArrayHelper.push({ tipo: null, observacoes: '', isExternal: false, dataExpedicao: null })
            saveCurrentState(values);
        }} />

    </div>)

}